<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title
        h1.subheading Customer Status
    div#customerCount
</template>

<script>
import dashbaordService from '../../service.js'
export default {
  mounted() {
    return dashbaordService.getCustomerCount()
    .then(data => {
      if(data){
        var newData = [
          {
            name: data.data.activeCustomerCount + ' Active',
            y: data.data.activeCustomerCount,
            sliced: true,
            selected: true,
            color: '#3B953E'
          },
          {
            name: data.data.cancelledCustomerCount + ' Cancelled',
            y:data.data.cancelledCustomerCount,
            color: '#BE2324'
          },
          {
            name:data.data.lockedCustomerCount + ' Locked',
            y:data.data.lockedCustomerCount,
            color: '#AA7DFF'
          },
          {
            name: data.data.onTrialCustomerCount +  ' On Trial',
            y:data.data.onTrialCustomerCount,
            color: '#0E3F97'
          }
        ];

        var HighChartPie = $('#customerCount');
        if (HighChartPie.length) {

          HighChartPie.highcharts({
            credits: false, // Disable HighCharts logo
            // colors: ['green', '#4a89dc', '#3bafda', '#8A1B1D'], // Set Colors
            chart: {
              plotBackgroundColor: null,
              plotBorderWidth: null,
              plotShadow: false,
              type: 'pie'
            },
            title: {
                text: null
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: false
                },
                showInLegend: true
              }
            },
            series: [{
              type: 'pie',
              colorByPoint: true,
              name: 'Status',
              data: newData
            }]
          });
        }
      }
    })
  }
  
}
</script>
